module.exports = __webpack_public_path__ + "static/media/pancakes.41798464.png";